import script from "./UploadTemplateStep.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadTemplateStep.vue?vue&type=script&setup=true&lang=js"

import "./UploadTemplateStep.vue?vue&type=style&index=0&id=8ebee60c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ebee60c"]])

export default __exports__